module.exports = __webpack_public_path__ + "static/media/untappd.3b3367ac.svg";